import axios from 'axios';
import { unwrapApiResponse } from './apiUtils';
import type { AdminContentModuleResponse, ContentItem, ContentModuleKey } from '../types/content';
import type { ApiResponse } from '../types/api';
import { buildApiUrl } from './apiBase';

const publicContentApi = axios.create({
  baseURL: buildApiUrl('/api/content'),
  timeout: 15000,
});

export async function fetchPublicContentModule<TItem extends ContentItem = ContentItem>(
  moduleKey: ContentModuleKey
) {
  const response = await publicContentApi.get<ApiResponse<AdminContentModuleResponse<TItem>>>(`/${moduleKey}`);
  return unwrapApiResponse(response);
}

export default publicContentApi;
